import { ca } from '@cian/analytics';
import { IPromoProduct } from '../../../types/product';

interface ITrackLinkClickParams {
  product: IPromoProduct;
  type: 'to_offers' | 'to_jk' | 'to_listingjk';
}

export const trackLinkClick = ({ product, type }: ITrackLinkClickParams) => {
  ca('eventSite', {
    action: 'Click',
    category: 'Promo',
    name: 'oldevent',
    label: type,
    products: [product],
  });
};
